import React from 'react'
import PropTypes from 'prop-types'

import Button from '@hixme-ui/button'

const DeclineMedicalButton = ({ isProcessing, handleClick }) => (
  <Button
    outline
    danger
    width="190px"
    submittingText="Declining..."
    submitting={isProcessing}
    onClick={handleClick}
    style={{ background: 'transparent' }}
  >
    Decline medical
  </Button>
)

DeclineMedicalButton.propTypes = {
  handleClick: PropTypes.func,
  isProcessing: PropTypes.bool,
}

DeclineMedicalButton.defaultProps = {
  handleClick: () => null,
  isProcessing: false,
}

export default DeclineMedicalButton
